// Who LoftLoom is, stated once: the homepage heading and the Organization and
// WebSite JSON-LD. Shared by the React homepage (src/pages/Index.tsx,
// src/components/JsonLd.tsx) and its prerendered copy (buildHomeBody in
// scripts/prerender-body.mjs), so a crawler that does not run JavaScript reads
// the same heading and the same structured data as a visitor.
const SITE = "https://loftloom.com";

/** The homepage's H1, on phones and desktop alike. */
export const HOME_H1 = "Modern furniture for loft living";

// Only claims that can be verified are published here: name, url, description,
// a real contact address and where orders ship. No telephone (the previous
// number was in the reserved fictional 555-01xx range), no postal address, no
// founding date, no opening hours and no ratings. `sameAs` lists only profiles
// confirmed to be LoftLoom's own (Pinterest, domain-claimed 2026-09-24); an
// unconfirmed one would merge this entity with someone else's.
export const ORGANIZATION_ID = `${SITE}/#organization`;
export const ORGANIZATION_SAME_AS = ["https://www.pinterest.com/LoftLoomFurniture/"];
export const ORGANIZATION_DESCRIPTION =
  "An online storefront for modern furniture, lighting and decor, shipped within the contiguous United States and Canada.";

// Deliberately an Organization, NOT a FurnitureStore: FurnitureStore is a
// LocalBusiness subtype and asserts premises a customer can visit. There are none.
export function organizationSchema(name = "LoftLoom", url = SITE) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": ORGANIZATION_ID,
    name,
    url,
    description: ORGANIZATION_DESCRIPTION,
    email: "hello@loftloom.com",
    currenciesAccepted: "USD",
    areaServed: [
      { "@type": "Country", name: "United States" },
      { "@type": "Country", name: "Canada" },
    ],
    sameAs: ORGANIZATION_SAME_AS,
  };
}

export function webSiteSchema(name = "LoftLoom", url = SITE) {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name,
    url,
    potentialAction: {
      "@type": "SearchAction",
      // The real search route; /category/<term> is a not-found page.
      target: `${url}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };
}

/** The homepage's JSON-LD blocks, in the order src/pages/Index.tsx renders them. */
export const homeSchemas = () => [webSiteSchema(), organizationSchema()];
